/* -------------------------- LICENSES -------------------------- */

/*!
Do not copy, modify, and/or redistribute. The content presented herein may not, under any circumstances,
be reproduced in whole or in any part or form without written permission from LearnHaus.
Copyright LearnHaus
*/

/* -------------------------- ACTION ICONS -------------------------- */

export const EPSILON_ACTION_ICONS = {
    contextDefault: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-file-text-ai">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M14 3v4a1 1 0 0 0 1 1h4" />
            <path d="M10 21h-3a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5" />
            <path d="M9 9h1" />
            <path d="M9 13h2.5" />
            <path d="M9 17h1" />
            <path d="M14 21v-4a2 2 0 1 1 4 0v4" />
            <path d="M14 19h4" />
            <path d="M21 15v6" />
        </svg>
    `,
    shareDefault: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-share-3">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M13 4v4c-6.575 1.028 -9.02 6.788 -10 12c-.037 .206 5.384 -5.962 10 -6v4l8 -7l-8 -7" />
        </svg>
    `,
    brief: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-message">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M8 9h8" />
            <path d="M8 13h6" />
            <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12" />
        </svg>
    `,
    social: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-brand-linkedin">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M8 11v5" />
            <path d="M8 8v.01" />
            <path d="M12 16v-5" />
            <path d="M16 16v-3a2 2 0 1 0 -4 0" />
            <path d="M3 7a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4l0 -10" />
        </svg>
    `,
    detailed: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-mail">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10" />
            <path d="M3 7l9 6l9 -6" />
        </svg>
    `,
    exit: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-x">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M18 6l-12 12" />
            <path d="M6 6l12 12" />
        </svg>
    `,
    check: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-check">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M5 12l5 5l10 -10" />
        </svg>
    `,
    warning: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-alert-triangle">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 9v4" />
            <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0" />
            <path d="M12 16h.01" />
        </svg>
    `,
    loading: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-loader-2">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 3a9 9 0 1 0 9 9" />
        </svg>
    `,
};

/* -------------------------- STATE -------------------------- */

export function createPromptShareState() {
    return {
        availability: `unknown`,
        availabilityChecked: false,
        warmupStarted: false,
        firstActivationArmed: false,
        warmupPromise: null,
        generationFailed: false,
        status: `idle`,

        briefText: null,

        socialText: null,
        socialPromise: null,

        formalText: null,
        formalPromise: null,

        fallbackReason: ``,
    };
}

/* -------------------------- BUTTON HELPERS -------------------------- */

export function setButtonState(button, iconEle, titleEle, text, iconSvg, disabled = false) {
    if (titleEle) titleEle.textContent = text;
    if (iconEle) iconEle.innerHTML = iconSvg;

    if (button) {
        button.setAttribute(`aria-disabled`, disabled ? `true` : `false`);
        button.style.pointerEvents = disabled ? `none` : ``;
        button.style.opacity = disabled ? `0.72` : ``;
        button.style.cursor = disabled ? `default` : `pointer`;
    }

    return true;
}

export function setupButton(button, label, handler) {
    if (!button) return false;

    button.setAttribute(`role`, `button`);
    button.setAttribute(`tabindex`, `0`);
    button.setAttribute(`aria-label`, label);
    button.style.cursor = `pointer`;

    button.addEventListener(`click`, handler);

    button.addEventListener(`keydown`, (event) => {
        if (![ `Enter`, ` ` ].includes(event.key)) return;

        event.preventDefault();
        handler(event);
    });

    return true;
}

export function getCloneIconAndTitle(button, selectors) {
    return {
        icon: button.querySelector(`[${selectors.shareIconAttr}]`) || button.querySelector(`[${selectors.contextIconAttr}]`),
        title: button.querySelector(`[${selectors.shareTitleAttr}]`) || button.querySelector(`[${selectors.contextTitleAttr}]`),
    };
}

export function createShareChoiceButton({
    shareButton,
    selectors,
    text,
    icon,
    label,
    type,
    onClick,
}) {
    if (!shareButton) return null;

    const button = shareButton.cloneNode(true);
    const parts = getCloneIconAndTitle(button, selectors);

    button.removeAttribute(`id`);
    button.querySelectorAll(`[id]`).forEach(child => child.removeAttribute(`id`));
    button.removeAttribute(selectors.shareDivAttr);
    button.removeAttribute(selectors.contextDivAttr);
    button.setAttribute(`shareChoiceButton`, type);

    button.removeAttribute(`style`);
    button.style.display = `flex`;
    button.style.visibility = `visible`;
    button.style.pointerEvents = ``;
    button.style.opacity = ``;
    button.style.cursor = `pointer`;

    setButtonState(button, parts.icon, parts.title, text, icon, false);
    setupButton(button, label, () => onClick(type));

    return {
        type,
        button,
        icon: parts.icon,
        title: parts.title,
        defaultText: text,
        defaultIcon: icon,
    };
}

export function setShareChoiceState(choice, text, icon, disabled = false) {
    if (!choice) return false;

    return setButtonState(choice.button, choice.icon, choice.title, text, icon, disabled);
}

export function resetShareChoiceState(choice) {
    if (!choice) return false;

    return setShareChoiceState(choice, choice.defaultText, choice.defaultIcon, false);
}

/* -------------------------- TEXT HELPERS -------------------------- */

export function toPlainText(value) {
    if (value === null || value === undefined) return ``;

    let text = String(value);

    text = text
        .replace(/<br\s*\/?>/gi, `\n`)
        .replace(/<\/p>/gi, `\n`)
        .replace(/<\/div>/gi, `\n`)
        .replace(/<\/li>/gi, `\n`);

    const div = document.createElement(`div`);
    div.innerHTML = text;
    text = div.textContent || div.innerText || ``;

    return text
        .replace(/\u00a0/g, ` `)
        .replace(/[ \t]+\n/g, `\n`)
        .replace(/\n{3,}/g, `\n\n`)
        .replace(/[ \t]{2,}/g, ` `)
        .trim();
}

export function hasContent(value) {
    if (Array.isArray(value)) return value.some(hasContent);
    if (value && typeof value == `object`) return Object.values(value).some(hasContent);
    return toPlainText(value).length > 0;
}

export function truncateText(text, maxChars = 900) {
    text = toPlainText(text);

    if (text.length <= maxChars) return text;

    return `${text.slice(0, maxChars - 3).trim()}...`;
}

export function truncateTextAtBoundary(text, maxChars = 900) {
    text = toPlainText(text);

    if (text.length <= maxChars) return text;

    const limit = Math.max(1, maxChars - 3);
    const slice = text.slice(0, limit).trim();
    const breakpoint = Math.max(
        slice.lastIndexOf(`. `),
        slice.lastIndexOf(`; `),
        slice.lastIndexOf(`, `),
        slice.lastIndexOf(` `)
    );
    const shouldUseBreakpoint = breakpoint > Math.floor(limit * 0.6);
    const trimmed = (shouldUseBreakpoint ? slice.slice(0, breakpoint) : slice)
        .replace(/[,:;.\-\s]+$/g, ``)
        .trim();

    return `${trimmed || slice}...`;
}

export function getFirstSentence(text) {
    text = toPlainText(text);

    if (!text) return ``;

    const match = text.match(/^[\s\S]*?[.!?](?:\s|$)/);
    return (match ? match[0] : text).trim();
}

export function sentenceCase(text) {
    text = toPlainText(text);

    if (!text) return ``;

    return `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
}

export function lowerFirst(text, preserveAcronyms = false) {
    text = toPlainText(text);

    if (!text) return ``;
    if (preserveAcronyms && /^[A-Z]{2}/.test(text)) return text;

    return `${text.charAt(0).toLowerCase()}${text.slice(1)}`;
}

export function finishSentence(text) {
    text = toPlainText(text)
        .replace(/\s*\.\.\.$/g, ``)
        .trim();

    if (!text) return ``;
    if (!/[.!?]$/.test(text)) text += `.`;

    return text;
}

/* -------------------------- SCORE / METRIC HELPERS -------------------------- */

export function getScoreBlockCount(score) {
    if (!Number.isFinite(score)) return null;

    return Math.max(0, Math.min(10, Math.round(score / 100)));
}

export function getScoreEmojiBar(score) {
    if (!Number.isFinite(score)) return ``;

    const filledCount = getScoreBlockCount(score);
    const emptyCount = 10 - filledCount;

    let filledEmoji = `\u{1F7E6}`;

    if (score >= 850) filledEmoji = `\u{1F7EA}`;
    else if (score >= 700) filledEmoji = `\u{1F7E9}`;
    else if (score >= 500) filledEmoji = `\u{1F7E6}`;
    else if (score >= 300) filledEmoji = `\u{1F7E8}`;
    else filledEmoji = `\u{2B1C}`;

    return `${filledEmoji.repeat(filledCount)}${`\u{2B1B}`.repeat(emptyCount)}`;
}

export function getTopTakeawayMetricText(canvas, limit = 3) {
    const metrics = Array.isArray(canvas?.takeaways?.data)
        ? canvas.takeaways.data
        : [];

    return metrics
        .slice(0, limit)
        .map(tile => {
            const label = toPlainText(tile?.label);
            const value = toPlainText(tile?.main);
            if (!label && !value) return ``;
            return `${label}: ${value}`;
        })
        .filter(Boolean)
        .join(` | `);
}

export function buildScoreShareLine(snap, includeBar = true) {
    if (!Number.isFinite(snap?.mainScore)) return ``;

    return [
        `${snap.mainScoreTitle}: ${snap.mainScore}/1000`,
        includeBar ? snap.scoreBar : ``,
    ].filter(Boolean).join(`\n`);
}

/* -------------------------- PROMPT API HELPERS -------------------------- */

export function getPromptBaseOptions() {
    return {
        expectedInputs: [
            {
                type: `text`,
                languages: [`en`],
            },
        ],
        expectedOutputs: [
            {
                type: `text`,
                languages: [`en`],
            },
        ],
    };
}

export function hasUserActivationForPromptApi() {
    return Boolean(
        navigator?.userActivation?.isActive ||
        navigator?.userActivation?.hasBeenActive
    );
}

export async function getPromptApiAvailability() {
    try {
        if (window.LanguageModel?.availability && window.LanguageModel?.create) {
            const availability = await window.LanguageModel.availability(getPromptBaseOptions());

            return availability || `unknown`;
        }

        if (window.ai?.languageModel?.capabilities && window.ai?.languageModel?.create) {
            const capabilities = await window.ai.languageModel.capabilities();

            if (capabilities?.available === `no`) return `unavailable`;

            return `available`;
        }
    } catch (error) {
        console.warn(`Prompt API availability check failed.`, error);
    }

    return `unavailable`;
}

export function browserHasPromptApiShape() {
    return Boolean(
        (window.LanguageModel?.availability && window.LanguageModel?.create) ||
        (window.ai?.languageModel?.capabilities && window.ai?.languageModel?.create)
    );
}

export function canUsePromptShareChoices(promptShareState) {
    if (!browserHasPromptApiShape()) return false;

    if (!promptShareState.availabilityChecked) return true;

    return [`available`, `downloadable`, `downloading`].includes(promptShareState.availability);
}

export function setPromptShareStatus(promptShareState, status) {
    promptShareState.status = status;
    return true;
}

export function getPromptShareLoadingText(promptShareState) {
    if ([`checking`, `loading-model`].includes(promptShareState.status)) return `Loading Model`;

    return `Preparing Results`;
}

export async function createPromptSession({
    system,
    label = `share`,
    setStatus = () => true,
}) {
    setStatus(`loading-model`);

    if (window.LanguageModel?.create) {
        return await window.LanguageModel.create({
            ...getPromptBaseOptions(),
            initialPrompts: [
                {
                    role: `system`,
                    content: system,
                },
            ],
            monitor(monitor) {
                monitor.addEventListener?.(`downloadprogress`, (event) => {
                    setStatus(`loading-model`);
                    console.log(
                        `Prompt API ${label} model download: ${Math.round(event.loaded * 100)}%`
                    );
                });
            },
        });
    }

    if (window.ai?.languageModel?.create) return await window.ai.languageModel.create();

    throw new Error(`Prompt API is not available.`);
}

export async function runPromptPipeline({
    label,
    system,
    stages,
    setStatus = () => true,
    cleanText = toPlainText,
}) {
    const session = await createPromptSession({ system, label, setStatus });

    try {
        let previousOutput = ``;

        for (let i = 0; i < stages.length; i++) {
            setStatus(`preparing-results`);

            const prompt = stages[i](previousOutput);
            let output = ``;

            if (window.LanguageModel?.create) {
                output = await session.prompt(prompt);
            } else {
                output = await session.prompt(`${system}\n\n${prompt}`);
            }

            previousOutput = cleanText(output);

            if (!previousOutput) throw new Error(`${label} stage ${i + 1} returned empty output.`);
        }

        return previousOutput;
    } finally {
        session.destroy?.();
    }
}

export function resolveTextWithFallback(promise, timeoutMs, fallbackFactory, label) {
    if (!promise) return Promise.resolve(fallbackFactory());

    return new Promise((resolve) => {
        let settled = false;

        const timeoutId = window.setTimeout(() => {
            if (settled) return;

            settled = true;
            console.warn(`${label} generation timed out; using non-AI fallback.`);
            resolve(fallbackFactory());
        }, timeoutMs);

        Promise.resolve(promise)
            .then((text) => {
                if (settled) return;

                settled = true;
                window.clearTimeout(timeoutId);
                resolve(toPlainText(text) || fallbackFactory());
            })
            .catch((error) => {
                if (settled) return;

                settled = true;
                window.clearTimeout(timeoutId);
                console.warn(`${label} generation failed; using non-AI fallback.`, error);
                resolve(fallbackFactory());
            });
    });
}

/* -------------------------- CLIPBOARD / SHARE HELPERS -------------------------- */

export async function copyTextToClipboard(text) {
    if (!text) return false;

    if (navigator?.clipboard?.writeText && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
    }

    const textarea = document.createElement(`textarea`);
    textarea.value = text;
    textarea.setAttribute(`readonly`, ``);
    textarea.style.position = `fixed`;
    textarea.style.top = `-9999px`;
    textarea.style.left = `-9999px`;
    textarea.style.opacity = `0`;

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();
    textarea.setSelectionRange(0, textarea.value.length);

    let copied = false;

    try {
        copied = document.execCommand(`copy`);
    } finally {
        document.body.removeChild(textarea);
    }

    return copied;
}

export function isPhoneOrTabletLikeDevice() {
    const ua = navigator?.userAgent || ``;
    const platform = navigator?.platform || ``;
    const maxTouchPoints = navigator?.maxTouchPoints || 0;
    const isiPadOS = platform === `MacIntel` && maxTouchPoints > 1;

    return Boolean(
        isiPadOS ||
        /Android|iPhone|iPad|iPod|Mobile|Tablet|Kindle|Silk|PlayBook|BlackBerry|webOS/i.test(ua)
    );
}

export function shouldUseNativeShareMenu() {
    return Boolean(navigator?.share && isPhoneOrTabletLikeDevice());
}

export async function shareOrCopyText(text, title = `Reflection 2.0 Result`) {
    if (!text) throw new Error(`No share text was provided.`);

    const url = window?.location?.href || ``;
    const textWithUrl = url ? `${text}\n\n${url}` : text;

    if (shouldUseNativeShareMenu()) {
        try {
            const payload = {
                title,
                text: textWithUrl,
            };

            if (navigator.canShare && !navigator.canShare(payload)) {
                throw new Error(`Native share does not support this text payload.`);
            }

            await navigator.share(payload);

            return `shared`;
        } catch (error) {
            if (error?.name == `AbortError`) return `shared`;

            console.warn(`Native share failed; falling back to clipboard.`, error);
        }
    }

    const copied = await copyTextToClipboard(textWithUrl);

    if (!copied) throw new Error(`Unable to share or copy text.`);

    return `copied`;
}
